 
///-------import section------///
import React, { useState,useEffect,useRef,useCallback  } from "react";
import {Dialog,DialogTitle,DialogContent,IconButton} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import SendIcon from "@mui/icons-material/Send";
import RefreshIcon from "@mui/icons-material/Refresh";
import ReactMarkdown from "react-markdown";
import chartImg from "../assets/Veechat_icon 1.svg";
import logoImg from "../assets/Ennvee_logo_white.svg";
import "../styles/chatbot.css";
import ThumbUpAltOutlinedIcon from "@mui/icons-material/ThumbUpAltOutlined";
import ThumbDownAltOutlinedIcon from "@mui/icons-material/ThumbDownAltOutlined";
import ThumbUpAltIcon from "@mui/icons-material/ThumbUpAlt";
import ThumbDownAltIcon from "@mui/icons-material/ThumbDownAlt";
import ChatbotSVG from "../assets/chatbot 1.svg";
import MinimizeIcon from "@mui/icons-material/Minimize";
// import silder from '../Components/HeroVideoSlider';
// import HeroVideoSlider from "../Components/HeroVideoSlider";


 
//-----------------------declaration part-----------------------------//
function Chatbot() {
  const [open, setOpen] = useState(false);
  const [userInput, setUserInput] = useState("");
  const [messages, setMessages] = useState([]);
  const handleInputChange = (event) => setUserInput(event.target.value);
  const [feedbackIndex, setFeedbackIndex] = useState(null);
  // const [, setFeedbackText] = useState("");
  const [isTypingDone, setIsTypingDone] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [displayedMessages, setDisplayedMessages] = useState([]);
  const [sessionId, setSessionId] = useState(generateSessionId());
  // const [, setUserRating] = useState(null); // 1 for up, 0 for down
  const messagesEndRef = useRef(null);
  const [stopTyping, setStopTyping] = useState(false);
  const [abortController, setAbortController] = useState(null);
  const [submittedFeedback, setSubmittedFeedback] = useState({}); // Tracks submitted feedback per message
  const inputRef = useRef(null);
  const chatRef = useRef(null);
  const feedbackTextareaRef = useRef(null);
const [isFromMinimize, setIsFromMinimize] = useState(false);
const [feedbackText, setFeedbackText] = useState("");
const [userRating, setUserRating] = useState(null);

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };
  //-------------------------open dialog functionality------------------//

//  const openDialog = useCallback(() => {
//   const saved = localStorage.getItem("chatHistory");
//     // const fromMinimize = sessionStorage.getItem("fromMinimize") === "true";

//   const now = Date.now();

//   if (saved) {
//     const { messages: savedMessages, timestamp } = JSON.parse(saved);
//     const isWithin10Minutes = now - timestamp <= 10 * 60 * 1000;

//     if (isWithin10Minutes) {
//       setMessages(savedMessages); // restore chat
//     } else {
//       localStorage.removeItem("chatHistory"); // expire old session
//       setMessages([
//         {
//           content: "Hey There! My name is Lumina. How can I help you?",
//           role: "ai",
//         },
//       ]);
//     }
//   } else {
//     setMessages([
//       {
//         content: "Hey There! My name is Lumina. How can I help you?",
//         role: "ai",
//       },
//     ]);
//   }
//    sessionStorage.removeItem("fromMinimize"); 

//   const session = generateSessionId();
//   setSessionId(session);
//   setUserInput("");
//   setOpen(true);
// }, []);

const openDialog = useCallback(() => {
  const saved = localStorage.getItem("chatHistory");
  const now = Date.now();

  if (saved && isFromMinimize) {
    const { messages: savedMessages, timestamp } = JSON.parse(saved);
    const isWithin10Minutes = now - timestamp <= 10 * 60 * 1000;

    if (isWithin10Minutes) {
      setMessages(savedMessages);
      setDisplayedMessages(savedMessages); // Show all immediately when from minimize
      setIsTypingDone(true);
    } else {
      localStorage.removeItem("chatHistory");
      initializeFreshChat();
    }
  } else {
    initializeFreshChat();
  }

  setIsFromMinimize(false); // Reset flag after opening
  const session = generateSessionId();
  setSessionId(session);
  setUserInput("");
  setOpen(true);
  // localStorage.setItem("chatbot",true);
  window.parent.postMessage({chatbotStatus:true},'https://ennvee.com')
}, [isFromMinimize]);

// ---------------------------intial meaage  function-----------------------------//
const initializeFreshChat = () => {
  setMessages([
    {
      content: "Hey There! My name is Lumina. How can I help you?",
      role: "ai",
    },
  ]);
  setDisplayedMessages([]); // Start empty to trigger word-by-word
};


//------------useeffect functionality scroll bottom---------//
 useEffect(() => {
  const scroll = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  const delay = feedbackIndex !== null ? 100 : 0;
  const timeout = setTimeout(scroll, delay);

  return () => clearTimeout(timeout);
}, [displayedMessages, isLoading, feedbackIndex]);

//---------------------useeffect of formatting reponse-------------------// 
// useEffect(() => {
//   const lastMsg = messages[messages.length - 1];
//   if (lastMsg?.role === "ai"  && displayedMessages.length < messages.length) {
//     setIsTypingDone(false);
//     const words = lastMsg.content.split(" ");
//     let index = 0;
//     let currentMsg = "";

//     const interval = setInterval(() => {
//       if (stopTyping) {
//         clearInterval(interval);
//         setIsTypingDone(true);
//         return;
//       }

//       if (index < words.length) {
//         currentMsg += (index === 0 ? "" : " ") + words[index];
//         setDisplayedMessages(prev => [
//           ...messages.slice(0, messages.length - 1),
//           { ...lastMsg, content: currentMsg }
//         ]);
//         index++;
//       } else {
//         clearInterval(interval);
//         setTimeout(() => setIsTypingDone(true), 300);
//       }
//     }, 80);

//     return () => clearInterval(interval);
//   } else {
//     setDisplayedMessages(messages);
//     setIsTypingDone(true);
//     scrollToBottom();
//   }
// }, [messages, stopTyping]); 

useEffect(() => {
  const lastMsg = messages[messages.length - 1];
  
  // Only do word-by-word for AI messages when not from minimize
  if (lastMsg?.role === "ai" && displayedMessages.length < messages.length && !isFromMinimize) {
    setIsTypingDone(false);
    const words = lastMsg.content.split(" ");
    let index = 0;
    let currentMsg = "";

    const interval = setInterval(() => {
      if (stopTyping) {
        clearInterval(interval);
        setIsTypingDone(true);
        return;
      }

      if (index < words.length) {
        currentMsg += (index === 0 ? "" : " ") + words[index];
        setDisplayedMessages(prev => [
          ...messages.slice(0, messages.length - 1),
          { ...lastMsg, content: currentMsg }
        ]);
        index++;
      } else {
        clearInterval(interval);
        setTimeout(() => setIsTypingDone(true), 300);
      }
    }, 80);

    return () => clearInterval(interval);
  } else if (!isFromMinimize) {
    setDisplayedMessages(messages);
    setIsTypingDone(true);
    scrollToBottom();
  }
}, [messages, stopTyping, isFromMinimize]);


 
////--------------use effect of auto focus the input field-------------// 
useEffect(() => {
  if (!isLoading && isTypingDone) {
    inputRef.current?.focus();
  }
}, [isTypingDone, isLoading]);


// ------------------- Focus immediately when dialog opens------------------//
useEffect(() => {
  if (open) {
    const timeout = setTimeout(() => {
      inputRef.current?.focus();
    }, 100);
    return () => clearTimeout(timeout);
  }
}, [open]);
//---------------------------feeed back index----------------------------------//
useEffect(() => {
  if (feedbackIndex !== null && feedbackTextareaRef.current) {
    feedbackTextareaRef.current.focus();
  }
}, [feedbackIndex]);


//----------------session store id random 32 bit ---------------//
function generateSessionId() {
  const timestamp = new Date().toISOString().replace(/[-:.TZ]/g, "");
  const randomStr = Array.from({ length: 32 }, () =>
    Math.random().toString(36).charAt(2)
  ).join("");
  return `${randomStr}_${timestamp}`;
}



 
 
  ///---------handle key press---------///
  const handleKeyPress = (event) => {
    if (event.key === "Enter") handleSubmitClick();
  };
 
 
///--------------------handle submit function-----------------///

 const handleSubmitClick = async () => {
    if (!userInput.trim()) return;
  
    if (abortController) {
      abortController.abort();
    }
   const newController = new AbortController();
    setAbortController(newController);
  
    let isStopped = false;
    let timeoutId;
    setStopTyping(false);
    setIsTypingDone(false);
    setFeedbackIndex(null);
    setUserRating(null);
    setFeedbackText("");
  
    const newMessages = [...messages, { content: userInput, role: "human" }];
    setMessages(newMessages);
    setUserInput("");
    setIsLoading(true);
  
    const formData = new FormData();
    formData.append("query", userInput);
    formData.append("session_id", sessionId);
     // Set 30s timeout
     timeoutId = setTimeout(() => {
     newController.abort();
  }, 30000);
  
    try {
      const response = await fetch("/submit", {
        method: "POST",
        body: formData,
        signal: newController.signal,
      });
       clearTimeout(timeoutId);
  
      if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
  
      const data = await response.json();
  
      if (!isStopped) {
        if (data.response) {
          setUserRating(true);

          setMessages((prev) => [
            ...prev,
            { content: data.response, role: "ai" },
          ]);
        } else {
          const followUpQuestion =
            "Please answer this additional question before proceeding.";
          setMessages((prev) => [
            ...prev,
            { content: followUpQuestion, role: "ai" },
          ]);
        }
      }
    } catch (error) {
  if (error.name === "AbortError") {
    isStopped = true;
    console.log("Fetch aborted due to timeout");
    setMessages((prev) => [
      ...prev,
      { content: "We can’t complete your request right now due to a connectivity issue. This may be caused by a network problem or a temporary system delay. Please wait a moment and try again", role: "ai" },
    ]);
  } else {
    console.error("Error:", error);
    setMessages((prev) => [
      ...prev,
      { content: "We can’t complete your request right now due to a connectivity issue. This may be caused by a network problem or a temporary system delay. Please wait a moment and try again", role: "ai" },
    ]);
  }
}
finally {
      clearTimeout(timeoutId);
      setIsLoading(false);
      setIsTypingDone(true);
    }
  };
  //-----------handle the stop button  functionality -----//
   const handleStopTyping = () => {
    if (abortController) {
      abortController.abort(); 
    }
    setStopTyping(true);
    setIsTypingDone(true);
    setIsLoading(false);
    const lastDisplayedMessage = displayedMessages[displayedMessages.length - 1];
    setMessages((prev) => {
      const lastMessage = prev[prev.length - 1];
      if (lastMessage.role === "ai") {
        const truncatedResponse = lastDisplayedMessage.content + "…";
        const updatedMessages = [
          ...prev.slice(0, -1),
          { ...lastMessage, content: truncatedResponse },
        ];
      return updatedMessages;
      }
      return prev;
    });
    setDisplayedMessages((prev) => {
      const last = prev[prev.length - 1];
      const truncatedDisplayed = last.content + "…";
      return [...prev.slice(0, -1), { ...last, content: truncatedDisplayed }];
    });
   };
  
//---------------------refresh functionlity----------------//

 const handleRefresh = async () => {
  
  // Generate a new session ID
  const newSessionId = generateSessionId();
  setSessionId(newSessionId);
  console.log("session id for refresh",newSessionId)
  // Reset UI state
  setMessages([
    {
      content: "Hey There! My name is Lumina. How can I help you?",
      role: "ai",
    },
  ]);
  setUserInput("");
    setDisplayedMessages([]); 

  setFeedbackIndex(null);
  setFeedbackText("");
  setUserRating(null);
  setStopTyping(false);      
  setIsTypingDone(false); 
  setSubmittedFeedback({});      
  setAbortController(null);
    setStopTyping(false);      

  const formData = new FormData();
  formData.append("session_id", newSessionId); 

  try {
    const response = await fetch("https://ennveeai.click/refresh", {
      method: "POST",
      body: formData,
    });

    if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);

    const data = await response.json();

    if (data.success) {
      console.log("Refresh successful:", data.success);
    } else {
      console.warn("Unexpected response from refresh API:", data);
    }
  } catch (error) {
    console.error("Error during refresh:", error);
  }
};     




//-----------------minimize functionlity---------------//


const handleMinimize = () => {
  const sessionData = {
    messages,
    timestamp: Date.now(),
  };
  localStorage.setItem("chatHistory", JSON.stringify(sessionData));
 setIsFromMinimize(true);
  setOpen(false);
  // localStorage.setItem("chatbot",false);
  window.parent.postMessage({chatbotStatus:false},'https://ennvee.com')
};

// -----------------------useEffect hook near your other useEffect hooks-----------------------//
useEffect(() => {
  function handleClickOutside(event) {
    if (open && chatRef.current && !chatRef.current.contains(event.target)) {
      handleMinimize(); // Use your existing minimize function
    }
  }

  document.addEventListener("mousedown", handleClickOutside);
  return () => {
    document.removeEventListener("mousedown", handleClickOutside);
  };
}, [open, handleMinimize]);

 useEffect(() => {
  sessionStorage.removeItem("fromMinimize"); 
  localStorage.removeItem("chatHistory");
}, []);
  //-------------------close functionlaity---------------------///
 

const closeDialog = () => {
  if (abortController) {
    abortController.abort(); // Cancel any ongoing fetch
  }

  // Clear saved session data
  localStorage.removeItem("chatHistory");
  sessionStorage.removeItem("fromMinimize");

  // Generate a new session ID
  const newSessionId = generateSessionId();
  setSessionId(newSessionId);


  const welcomeMessage = {
    content: "Hey There! My name is Lumina. How can I help you?",
    role: "ai",
  };
  setUserInput("");
  setMessages([welcomeMessage]);
  
  setStopTyping(false);
  setIsTypingDone(false);
  setFeedbackIndex(null);
  setFeedbackText("");
  setUserRating(null);
  setSubmittedFeedback({});
  setAbortController(null);
  setOpen(false);
  // localStorage.setItem("chatbot",false);
  window.parent.postMessage({chatbotStatus:false},'https://ennvee.com')
};




//-----------------------submitfeedback button functionality--------------------////
  // const submitFeedback = async () => {
  //   if (feedbackIndex === null || userRating === null) return;
  
  //   const aiResponse = messages[feedbackIndex]?.content;
  //   const formData = new FormData();
  //   formData.append("query", messages.find(msg => msg.role === "human")?.content || "");
  //   formData.append("response", aiResponse);
  //   formData.append("user_response", userRating.toString()); // 1 or 0
  //   formData.append("user_comments", feedbackText);
  //   formData.append("session_id", sessionId);
  
  //   try {
  //     const response = await fetch("/submit-feedback", {
  //       method: "POST",
  //       body: formData,
  //     });
  
  //     if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
  //     const result = await response.json();
  //     console.log("Feedback submitted successfully:", result);
  
  //     setSubmittedFeedback(prev => ({
  //       ...prev,
  //       [feedbackIndex]: userRating,
  //     }));
  
  //   } catch (error) {
  //     console.error("Error submitting feedback:", error);
  //   } finally {
  //     setFeedbackIndex(null);
  //     setUserRating(null);
  //     setFeedbackText("");
    //   }
    // };
    
//   const submitFeedback = async (index, rating) => {
//     if (index === null || rating === null) return;

//     const aiResponse = messages[index]?.content;
//     const staticComment = rating === 1 ? "Positive" : "Negative";
    
//     const formData = new FormData();
//     formData.append("query", messages.find(msg => msg.role === "human")?.content || "");
//     formData.append("response", aiResponse);
//     formData.append("user_response", rating.toString());
//     formData.append("user_comments", staticComment);
//     formData.append("session_id", sessionId);

//     try {
//       const response = await fetch("/submit-feedback", {
//         method: "POST",
//         body: formData,
//       });

//       if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
//       const result = await response.json();
//       console.log("Feedback submitted successfully:", result);

//       setSubmittedFeedback(prev => ({
//         ...prev,
//         [index]: rating,
//       }));
//     } catch (error) {
//     console.error("Error submitting feedback:", error);
//   }
// };

const submitFeedback = async (index = feedbackIndex, rating = userRating) => {
  if (index === null || rating === null) return;

  const aiResponse = messages[index]?.content;
  const staticComment = feedbackText.trim() || (rating === 1 ? "Positive" : "Negative");

  const formData = new FormData();
  formData.append("query", messages.find(msg => msg.role === "human")?.content || "");
  formData.append("response", aiResponse);
  formData.append("user_response", rating.toString());
  formData.append("user_comments", staticComment);
  formData.append("session_id", sessionId);

  try {
    const response = await fetch("/submit-feedback", {
      method: "POST",
      body: formData,
    });

    if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
    const result = await response.json();
    console.log("Feedback submitted successfully:", result);

    setSubmittedFeedback(prev => ({
      ...prev,
      [index]: rating,
    }));

    // Reset feedback state
    setFeedbackIndex(null);
    setUserRating(null);
    setFeedbackText("");
  } catch (error) {
    console.error("Error submitting feedback:", error);
  }
};




// const submitFeedback = async () => {
//   if (feedbackIndex === null || userRating === null) return;

//   const aiResponse = messages[feedbackIndex]?.content;
//   const staticComment = feedbackText.trim() || (userRating === 1 ? "Positive" : "Negative");

//   const formData = new FormData();
//   formData.append("query", messages.find(msg => msg.role === "human")?.content || "");
//   formData.append("response", aiResponse);
//   formData.append("user_response", userRating.toString());
//   formData.append("user_comments", staticComment);
//   formData.append("session_id", sessionId);

//   try {
//     const response = await fetch("/submit-feedback", {
//       method: "POST",
//       body: formData,
//     });

//     if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
//     const result = await response.json();
//     console.log("Feedback submitted successfully:", result);

//     setSubmittedFeedback(prev => ({
//       ...prev,
//       [feedbackIndex]: userRating,
//     }));

//     // Reset feedback input
//     setFeedbackIndex(null);
//     setUserRating(null);
//     setFeedbackText("");
//   } catch (error) {
//     console.error("Error submitting feedback:", error);
//   }
// };


//--------------------------- Toggle feedback selection----------------------//
// const toggleFeedback = (index, rating) => {
//   if (submittedFeedback[index] !== undefined) return;
//  if (feedbackIndex === index && userRating === rating) {
//     setFeedbackIndex(null);
//     setUserRating(null);
//     setFeedbackText("");
//   } else {
//     setFeedbackIndex(index);
//     setUserRating(rating);
//     setFeedbackText("");
//   }
// };

const toggleFeedback = (index, rating) => {
  if (submittedFeedback[index] !== undefined) return;

  if (feedbackIndex === index && rating === 1) {
  
    return;
  }

  setFeedbackIndex(index);
  setUserRating(rating);
  setFeedbackText("");
};

useEffect(() => {
  function handleClickOutsideFeedback(event) {
    if (
      feedbackTextareaRef.current &&
      !feedbackTextareaRef.current.contains(event.target)
    ) {
      cancelFeedback(); // Close feedback box
    }
  }

  if (feedbackIndex !== null && userRating === 0) {
    document.addEventListener("mousedown", handleClickOutsideFeedback);
  }

  return () => {
    document.removeEventListener("mousedown", handleClickOutsideFeedback);
  };
}, [feedbackIndex, userRating]);

 
  //-------------------------------------cancel button functionality-------------------------------////
  const cancelFeedback = () => {
    setFeedbackIndex(null);
    setFeedbackText("");
    setUserRating(null);
 
  };
 

  
 
  return (
   <div>
    {/* ------veechat design------- */}
    <div className="img-container" onClick={openDialog}>
  <svg width="100" height="50" className="arc-text">
    <defs>
      <path id="arcPath" d="M10,50 A40,40 0 0,1 90,50" />
    </defs>
    <text fill="#e6a168" fontSize="14" fontFamily="Arial">
      <textPath href="#arcPath" startOffset="50%" textAnchor="middle">
        veeChat
      </textPath>
    </text>
  </svg>
  <img src={chartImg} alt="Chatbot" />
</div>


  <div className="dialog-content">
<Dialog  open={open} onClose={closeDialog} maxWidth="sm" fullWidth PaperProps={{ className: "custom-dialog",ref: chatRef }}  BackdropProps={{ className: "custom-backdrop" }}>
         {/*--------- diglog title functionlity ----------*/}
        <DialogTitle className="dialog-title">
          <img src={logoImg} alt="Logo" className="logo-image" />
          <div className="icon-buttons">
          <div className="refreshicon">
            <IconButton onClick={handleRefresh} aria-label="refresh" className="refresh-icon">
              <RefreshIcon />
            </IconButton>

          </div>
            <IconButton
      aria-label="minimize"
      onClick={handleMinimize}
      style={{ position: "absolute", right: 70, top:2, color: "white" }}
    >
      <MinimizeIcon />
    </IconButton>
          <IconButton aria-label="close" onClick={closeDialog} style={{ position: "absolute", right: 10, top: 10, color: "white" }}>
            <CloseIcon />
          </IconButton>

         </div>
        </DialogTitle>
      
      {/*-----------dialog content functionality------------ */}
  <DialogContent className="dialog-content">
  {/* <HeroVideoSlider/> */}
  <div className="chat-messages">
    {displayedMessages.map((msg, index) => (
      <div key={index} className={`message-wrapper ${msg.role === "human" ? "user-wrapper" : "bot-wrapper"}`} >
        <div className="message-content">
           {msg.role === "ai" && (
            <img src={require("../assets/AI.png")} alt="AI" className={msg.role === "human" ? "avatar-img1" : "avatar-img2"}/>
          )}

          <div className={`message-container ${ msg.role === "human" ? "user-message" : "bot-message" }`}>
            <div className="message-text">
              <ReactMarkdown components={{a: ({ node, children, ...props }) => (
      <a {...props} target="_blank" rel="noopener noreferrer" className="chat-link">
        {children}
      </a>), }}>{msg.content}</ReactMarkdown>
          </div>
          </div>

          {msg.role === "human" && (
            <img src={ChatbotSVG} alt="User" className="avatar-img1" />
          )}
        </div>
        {/*------- Feedback section------------ */}
        {/* {msg.role === "ai" &&
  messages[index]?.content === msg.content &&isTypingDone &&index !== 0 && (
    <>
 <div className="feedback-buttons">
  <IconButton onClick={() => toggleFeedback(index, 1)} className={`thumb-button
   ${
      submittedFeedback[index] !== undefined ? "disabled" : ""
    } ${
      (submittedFeedback[index] === 1 || (feedbackIndex === index && userRating === 1))
        ? "selected-up"
        : ""
    }`}
    disabled={submittedFeedback[index] !== undefined} >
    {(submittedFeedback[index] === 1 || (feedbackIndex === index && userRating === 1)) ? (
      <ThumbUpAltIcon />
    ) : (
      <ThumbUpAltOutlinedIcon />
    )}
  </IconButton>

  <IconButton onClick={() => toggleFeedback(index, 0)}className={`thumb-button 
  ${
    submittedFeedback[index] !== undefined ? "disabled" : ""
    } ${
      (submittedFeedback[index] === 0 || (feedbackIndex === index && userRating === 0))
        ? "selected-down"
        : ""
    }`}
    disabled={submittedFeedback[index] !== undefined} >
    {(submittedFeedback[index] === 0 || (feedbackIndex === index && userRating === 0)) ? (
      <ThumbDownAltIcon />
    ) : (
      <ThumbDownAltOutlinedIcon />
    )}
  </IconButton>
</div> */}
{msg.role === "ai" &&
  messages[index]?.content === msg.content &&
  isTypingDone &&
  index !== 0 && (
    <>
      <div className="feedback-buttons">
      <IconButton
  onClick={() => {
    cancelFeedback(); // 👈 Close feedback box if open
    submitFeedback(index, 1);
  }}
  className={`thumb-button ${
    submittedFeedback[index] !== undefined ? "disabled" : ""
  } ${submittedFeedback[index] === 1 ? "selected-up" : ""}`}
  disabled={submittedFeedback[index] !== undefined}
>
          {submittedFeedback[index] === 1 ? (
            <ThumbUpAltIcon />
          ) : (
            <ThumbUpAltOutlinedIcon />
          )}
        </IconButton>

        <IconButton
          // onClick={() => submitFeedback(index, 0)}
          onClick={() => 
            toggleFeedback(index, 0)}

          className={`thumb-button ${
            submittedFeedback[index] !== undefined ? "disabled" : ""
          } ${submittedFeedback[index] === 0 ? "selected-down" : ""}`}
          disabled={submittedFeedback[index] !== undefined}
        >
          {submittedFeedback[index] === 0 ? (
            <ThumbDownAltIcon />
          ) : (
            <ThumbDownAltOutlinedIcon />
          )}
        </IconButton>
      </div>
  

  {/*----------------- Feedback comment box (only shown before submission)--------------------------- */}
      {feedbackIndex === index && userRating === 0 &&  (
        <div className="feedback-box" ref={feedbackTextareaRef}>
          {/* <CloseIcon className="feedback-close-icon" onClick={cancelFeedback} /> */}
          <textarea rows="2"   
           placeholder="Type your feedback"
            value={feedbackText}
            onChange={(e) => setFeedbackText(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter" && !e.shiftKey) {
                e.preventDefault();
                submitFeedback();
              }
            }}
          />
          <div className="feedback-actions">
 <SendIcon
      onClick={() => {
        setUserRating(0);
        setFeedbackIndex(index);
        submitFeedback(index, 0);
        cancelFeedback(); 
      }}
      className="send-icon"
    />          </div>
        </div>
      )}



    </> 
  )}

</div>
    ))}

    {/*-------- Typing animation loading --------------*/}
    {isLoading && (
  <div className="message-wrapper bot-wrapper">
    <div className="message-content">
      <img
        src={require("../assets/AI.png")}
        alt="AI"
        className="avatar-img2"
      />
      <div className="message-container bot-message">
        <div className="message-text typing">
          <span>.</span>
          <span>.</span>
          <span>.</span>
        </div>
      </div>
    </div>
  </div>
)}


    {/*------------ Auto-scroll anchor---------- */}
    <div ref={messagesEndRef} />
  </div>
</DialogContent>
    {/* ---------input container ------------- */}
    <div className="input-container">
  <input
    type="text"
       ref={inputRef}
       id="chatInput"
    placeholder="Type your query"
    value={userInput}
    onChange={handleInputChange}
    onKeyPress={handleKeyPress}
    className="chat-input"
    disabled={isLoading}
  />

{(isLoading || !isTypingDone) && messages.length > 1 ? (
  <div className="stop-button" onClick={handleStopTyping}>
    <div className="inner-square"></div>
  </div>
) : (
  <IconButton
    onClick={handleSubmitClick}
    className="submit-icon"
    disabled={!userInput.trim()}
  >
    <SendIcon />
  </IconButton>
)}

</div>

      </Dialog>
    </div>
    </div>
  );
}
 
export default Chatbot;